import React from "react"
import PropTypes from "prop-types"

import { BaseLink } from "../../style/css/baseLink"
export function MfLink({ href, children, ...props }) {
  return (
    <BaseLink href={href} {...props}>
      {children}
    </BaseLink>
  )
}

MfLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
}
